import authorisationProblems from './authorisationProblems';

export default Object.freeze({
  [authorisationProblems.ACCOUNT_DISABLED]: '/webshop/accountDisabled.do',
  [authorisationProblems.SINGLE_USE_PASSWORD]: '/webshop/changeSingleUsePassword.go',
  [authorisationProblems.FAILED_PAYMENTS]: '/webshop/getFailedPaymentOrders.go',
});
